import React, { useState, useEffect, useCallback } from 'react';
import Grid from '@mui/material/Grid2';
import { 
  DisablableOption, 
  IStringHash, 
  PlayerObject, 
} from "@models";
import { DataType, isDataType } from '@dndModels/Types';

import DandDAPI from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";
import DandDCharacterUtilities from '@dndUtilities/char_utilities';

import StringBox from "@components/input/strings/StringBox";
import SelectStringBox from "@components/input/selects/SelectStringBox";
import LoadingBox from "@components/input/LoadingBox";
import FilterBox from "@dndComponents/filtering/FilterBox";

const api = DandDAPI.getInstance();
const common_util = CommonUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

interface Props {
  data_type: DataType | "";
  value?: string;
  values?: string[];
  filter?: any;
  filters?: any;
  extra_filter?: (o: PlayerObject) => boolean;
  // character_options?: CharacterOptions;
  extras_from_fields?: any;
  options?: DisablableOption[];
  extra_options?: string[];
  allow_all?: boolean;
  allow_none?: boolean;
  allow_true_none?: boolean;
  multiple?: boolean;
  name: string;
  onChange?: Function | null; 
  onChangeWithDataTypes?: ((ids: { 
    id: string, data_type: string, 
  }[]) => void) | null;
  onChangeObject?: Function | null; 
  labelWidth?: number | null;
  color?: string;
  disabled?: boolean;
  display_format?: string;
  render_value_format?: string;
  display_format_backup?: string;
  limit?: number;
  internal_filter?: boolean;
  log_it?: boolean;
  use_width_finder?: boolean;
  auto_sort?: boolean;
  close_on_extra_clicked?: boolean;
  ignore_missing?: boolean;
  images?: boolean;
  show_current_order?: boolean;
  auto_select_on_1?: boolean;
  max_selected?: number;
  reload_time?: number;
  sort?: (obj1: PlayerObject, obj2: PlayerObject) => number;
}

export default function SelectPlayerObjectBox({ 
  name,
  data_type,
  // multiple=false,
  max_selected = -1,
  value,
  values,
  color="",
  options=[],
  extra_options=[],
  allow_all = false,
  allow_none = false,
  allow_true_none = false,
  filter={},
  filters={},
  extra_filter,
  // character_options,
  extras_from_fields={},
  disabled=false,
  display_format="{obj.true_name}",
  render_value_format="",
  display_format_backup="{obj.name}",
  sort,
  limit=-1,
  internal_filter=false,
  onChange=null,
  onChangeWithDataTypes=null,
  onChangeObject=null,
  log_it=false,
  close_on_extra_clicked = false,
  ignore_missing = false,
  // use_width_finder=false,
  // // labelWidth=null,
  auto_sort=true,
  images = false,
  show_current_order = false,
  auto_select_on_1 = false,
  reload_time = 0
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data_loaded, setDataLoaded] = useState(false);
  // const [width, setWidth] = useState(-1);
  const [search, setSearch] = useState("");
  const [searching, setSearching] = useState(false);
  const [my_extra_options, setExtraOptions] = useState(extra_options);
  const [data_type_map, setDataTypeMap] = useState<IStringHash>({});
  const [data_type_map2, setDataTypeMap2] = useState<IStringHash>({});
  const [objects, setObjects] = useState<PlayerObject[]>([]); 
  const [my_options, setOptions] = useState<DisablableOption[]>([]);
  const [my_values, setValues] = useState<string[]>(values ? values : []);
  const [my_reload_time, setReloadTime] = useState(reload_time);
  const [use_filter, setFilter] = useState<any>({});
  const [width, setWidth] = useState(-1);
  
  const widthFinder: any = React.createRef();

  // passing an empty array as second argument triggers the callback in useEffect
  // only after the initial render thus replicating `componentDidMount` lifecycle behaviour
  useEffect(() => {
    if(!fetched) {
      load();
    }
  });

  useEffect(() => {
    if (log_it) {
      // debugger;
    }
    if (data_loaded) {
      load_options();
    // } else {
    //   setLoading(false);
    }
    // eslint-disable-next-line
  }, [objects, search, use_filter, log_it]);

  useEffect(() => {
    if (reload_time !== my_reload_time) {
      setValues(values ? values : []);
      setReloadTime(reload_time);
    }
    // eslint-disable-next-line
  }, [reload_time, my_reload_time]);

  const updateFilter = (the_filter: any) => {
    const new_filter = {...the_filter};
    if (log_it) {
      console.log(new_filter);
    }
    setFilter(new_filter);
  }

  const load = useCallback( async () => {
    setFetched(true);
    setLoading(true);
    if (widthFinder && widthFinder.current instanceof HTMLElement) {
      setWidth(widthFinder.current.offsetWidth);
    }
    if (log_it) {
      debugger;
    }
    if (isDataType(data_type)) {
      const res = await api.getPlayerObjects({ data_type, filter });
      if (log_it) {
        debugger;
      }
      let new_objects: PlayerObject[] = [];
      const new_extra_options = [...my_extra_options];
      const new_data_type_map = data_type_map2;
      const objects_of_type = res;
      new_objects = [...new_objects,...objects_of_type];
      if (log_it) {
        console.log(new_data_type_map);
      }
      if (internal_filter && new_objects.length > 0 && value) {
        const obj = new_objects.filter(o => o._id === value)[0];
        if (obj) {
          setSearch(obj.name);
        }
      }
      setDataLoaded(true);
      setExtraOptions(common_util.unique_array(new_extra_options));
      setDataTypeMap2(new_data_type_map);
      setObjects(new_objects);
    }
  }, []);

  const sorter = (a: PlayerObject, b: PlayerObject) => {
    if (sort) {
      const sort_value = sort(a, b);
      if (sort_value !== 0) {
        return sort_value;
      }
    }
    return a.use_name.trim().localeCompare(b.use_name.trim()); 
  }

  const load_options = async () => {
    if (log_it) {
      console.log(my_extra_options);
      console.log(objects);
      debugger;
    }
    let new_options = options;
    let new_extra_options: DisablableOption[] = [];
    const new_data_type_map = data_type_map2;
    for (const extra_option of my_extra_options) {
      new_extra_options.push({ id: extra_option, text: extra_option, disabled: false, reason: "" });
      if (new_data_type_map[extra_option] === undefined) {
        new_data_type_map[extra_option] = "extra_option";
      }
    }
    if (log_it) {
      console.log(new_options);
    }
    const string_limit = 50;
    let filtered_objects = objects;
    if (data_type !== "") {
      if (Object.keys(use_filter).length > 0) {
        filtered_objects = api.filter(data_type, filtered_objects, use_filter);
      }
    } else {
      if (search !== "") {
        const pieces = search.split(" ");
        for (const piece of pieces) {
          filtered_objects = filtered_objects.filter(o => o.name.toLowerCase().includes(piece.toLowerCase()));
        }
      }
    }
    if (log_it) {
      // debugger;
      console.log(filtered_objects);
    }
    if (extra_filter) {
      filtered_objects = filtered_objects.filter(o => extra_filter(o));
    }
    if (sort) {
      filtered_objects = filtered_objects.sort(sorter);
    }
    for (const opt of filtered_objects) {
      let text = await char_util.getStringWithReplacementsWithObjectAsync({ clean_me: display_format, backup: display_format_backup, obj: opt });
      if (text.length > string_limit) {
        text = text.substring(0, string_limit) + "...";
      }
      let value_text = render_value_format === "" ? "" : await char_util.getStringWithReplacementsWithObjectAsync({ clean_me: render_value_format, backup: render_value_format, obj: opt });
      if (value_text.length > string_limit) {
        value_text = value_text.substring(0, string_limit) + "...";
      }
      new_options.push({ id: opt._id, text, value_text: value_text === "" ? undefined : value_text, image_url: opt.image_url, disabled: false, reason: "" });
      if (opt instanceof PlayerObject) {
        new_data_type_map[opt._id] = opt.data_type; 
      } else if (onChangeWithDataTypes !== null) {
        console.log(opt);
      }
    }
    if (log_it) {
      console.log(new_data_type_map);
      // debugger;
    }
    if (auto_sort && !sort) {
      new_options = new_options.sort((a,b) => { return a.text.localeCompare(b.text) });
      new_extra_options = new_extra_options.sort((a,b) => { return a.text.localeCompare(b.text) });
    }
    new_options = [...new_extra_options,...new_options];
    if (auto_select_on_1 && new_options.length === 1) {
      const new_value = new_options[0].id;
      if (new_value !== value) {
        if (onChangeWithDataTypes !== null) {
          const id = new_value;
          onChangeWithDataTypes([{ id, data_type: data_type_map[id] }]);
        } else if (onChange !== null) {
          onChange(new_value);
        } else if (onChangeObject !== null) {
          if (extra_options.includes(new_value)) {
            onChangeObject(new_value);
          }
          const id = new_value;
          const obj_finder = objects.filter(o => o._id === id);
          if (obj_finder.length === 1) {
            onChangeObject(obj_finder[0]);
          }
        }
      }
    }
    setOptions(new_options);
    setDataTypeMap(new_data_type_map);
    setLoading(false);
    setSearching(false);
  }

  const renderControl = () => {
    if (limit > -1 && (my_options.length > limit || Object.keys(use_filter).length > 0)) {
      if (internal_filter) {
        const filtered_objects = my_options; // search === "" ? objects : objects.filter(o => o.name.toLowerCase().includes(search.toLowerCase()));
        return (
          <Grid container spacing={0} direction="row">
            <Grid
              size={{
                xs: 12
              }}>
              { data_type !== "" ? 
                <FilterBox flat
                  the_filter={use_filter}
                  dont_use_api
                  data_type={data_type}
                  all_objects={objects}
                  onChange={updateFilter}
                  onLoad={updateFilter}
                />
              :
                <StringBox
                  name="Search"
                  value={search}
                  disabled={disabled}
                  onBlur={(new_search: string) => {
                    setSearching(true);
                    setSearch(new_search);
                  }}
                />
              }
            </Grid>
            <Grid
              size={{
                xs: 12
              }}>
              { searching ?
                <span>Searching</span>
              : filtered_objects.length <= limit ? 
                renderControl2() 
              :
                <span>Too many results ({ filtered_objects.length }, limit is { limit })</span>
              }
            </Grid>
          </Grid>
        );
      } else {
        return <div>Too many { data_type } ({ my_options.length }, limit is { limit })</div>;
      }
    } else {
      return renderControl2();
    }
  }

  const renderControl2 = () => {
    // if (log_it) {
    //   debugger;
    // }
    const new_extra_options: (string | DisablableOption)[] = [];
    if (values !== undefined) {
      // const orphaned = !ignore_missing && my_values.filter(o => 
      //   my_options.filter(o2 => o2.id === o).length === 0).length > 0;
      if (allow_all) {
        new_extra_options.push({ id: "All", text: "All" });
      }
      if (allow_none) {
        new_extra_options.push({ id: "None", text: "None" });
      } else if (allow_true_none) {
        new_extra_options.push({ id: "True None", text: "None" });
      }
      const select = (
        <SelectStringBox
          name={name}
          options={my_options}
          extra_options={new_extra_options}
          watch_me={my_extra_options}
          disabled={disabled}
          values={my_values}
          // multiple
          max_selected={max_selected}
          close_on_extra_clicked={close_on_extra_clicked}
          ignore_missing={ignore_missing}
          reload_time={my_reload_time}
          images={images}
          show_current_order={show_current_order}
          width={width}
          onChange={(changed: string[]) => {
            // debugger;
            if (changed.includes("Remove Orphaned Values")) {
              changed = changed.filter(o => 
                my_options.find(o2 => o2.id === o));
              setValues(changed);
              setReloadTime(common_util.get_time_number());
            } else if (changed.includes("All")) {
              changed = my_options.map(o => o.id);
              setValues(changed);
              setReloadTime(common_util.get_time_number());
            } else if (changed.includes("None")) {
              changed = [];
              setValues(changed);
              setReloadTime(common_util.get_time_number());
            } else {
              setValues(changed);
            }
          }}
          onClose={(changed: string[]) => {
            // debugger;
            if (onChangeWithDataTypes !== null) {
              const ids_with_data_types: { 
                id: string, data_type: string, 
              }[] = [];
              changed.forEach(id => {
                ids_with_data_types.push({ id, data_type: data_type_map[id] });
              });
              if (log_it) {
                console.log(changed);
                console.log(data_type_map);
                console.log(ids_with_data_types);
              }
              onChangeWithDataTypes(ids_with_data_types);
            } else if (onChange !== null) {
              onChange(changed);
            } else if (onChangeObject !== null) {
              const obj_finder = objects.filter(o => changed.includes(o._id));
              onChangeObject(obj_finder);
            }
            setValues(changed);
          }}
        />
      );
      // if (orphaned) {
      //   return (
      //     <Grid container spacing={0} direction="row">
      //       <Grid item xs={8}>{ select }</Grid>
      //       <Grid item xs={4}>
      //         <ButtonBox
      //           name="Remove Orphaned Values"
      //           onClick={() => {
      //             const changed = values.filter(o => 
      //             my_options.find(o2 => o2.id === o));
      //             if (onChangeWithDataTypes !== null) {
      //               const ids_with_data_types: { 
      //                 id: string, data_type: string, 
      //               }[] = [];
      //               changed.forEach(id => {
      //                 ids_with_data_types.push({ id, data_type: data_type_map[id] });
      //               });
      //               if (log_it) {
      //                 console.log(changed);
      //                 console.log(data_type_map);
      //                 console.log(ids_with_data_types);
      //               }
      //               onChangeWithDataTypes(ids_with_data_types);
      //             } else if (onChange !== null) {
      //               onChange(changed);
      //             } else if (onChangeObject !== null) {
      //               const obj_finder = objects.filter(o => changed.includes(o._id));
      //               onChangeObject(obj_finder);
      //             }
      //             setValues(changed);
      //           }}
      //         />
      //       </Grid>
      //     </Grid>
      //   )
      // } else {
        return select;
      // }
    } else {
      if (allow_all) {
        new_extra_options.push({ id: "All", text: "All" });
      }
      if (allow_none) {
        new_extra_options.push({ id: "None", text: "None" });
      } else if (allow_true_none) {
        new_extra_options.push({ id: "True None", text: "None" });
      }
      if (auto_select_on_1 && my_options.length === 1) {
        return (
          <>
            { my_options[0].text }
          </>
        );
      } else {
        return (
          <SelectStringBox
            name={name}
            options={my_options}
            disabled={disabled}
            value={value}
            images={images}
            onChange={(changed: string) => {
              if (onChangeWithDataTypes !== null) {
                const id = changed;
                onChangeWithDataTypes([{ id, data_type: data_type_map[id] }]);
              } else if (onChange !== null) {
                onChange(changed);
              } else if (onChangeObject !== null) {
                if (extra_options.includes(changed)) {
                  onChangeObject(changed);
                }
                const id = changed;
                const obj_finder = objects.filter(o => o._id === id);
                if (obj_finder.length === 1) {
                  onChangeObject(obj_finder[0]);
                }
              }
            }}
          />
        );
      }
    }
  }

  if (log_it) {
    console.log(my_options);
    console.log(objects);
    // debugger;
  }
  if (!fetched || loading) {
    return <span ref={widthFinder}><LoadingBox /></span>;
  } else {
    // return (<span></span>);
    if (color !== "") {
      return (
        <div style={{
          border: "1px solid #1C9AEF"
        }}>
          { renderControl() }
        </div>
      );
    } else {
      return renderControl();
    }
  }
}
